module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av13-57e6ba7fcdf4a70144cdc91c8be5ea2b.jpg";